import geolib from "geolib";

import * as t from "./types";
import { createReducer } from "../../util";

const initState = {
    ungroupedLocations: [],
    manyItemStates: [], // for now, just texas
    fewItemStates: [], // every other states besides texas
    geographicCenter: {
        //Brownwood, Texas
        lat: 31.7093,
        lng: -98.9912
    },
    showingAll: false,
    error: null,
    jumpToCurrentLocationError: null,
    loading: false
};

const getSortedStateNames = locations =>
    [
        ...new Set(
            locations
                // need to make sure location has a name
                .filter(location => !!location.name)
                .map(location => location.state)
        )
    ]
        // stort the state names by alpha
        .sort();

const groupLocationsByState = locations =>
    getSortedStateNames(locations)
        // for each state name, add state code and location data
        .map(stateName => ({
            stateName,
            stateCode: locations.find(location => location.state === stateName)
                .statecode,
            locations: locations.filter(
                location => location.state === stateName
            )
        }));

const getManyItemStates = location =>
    groupLocationsByState(location).filter(
        location => location.stateName === "Texas"
    );

const getFewItemStates = location =>
    groupLocationsByState(location).filter(
        location => location.stateName !== "Texas"
    );

const getGeographicCenter = locations => {
    if (locations.length < 1) {
        return null;
    }
    const center = geolib.getCenter(
        locations.map(location => ({
            latitude: Number(location.latitude),
            longitude: Number(location.longitude)
        }))
    );
    return {
        lat: Number(center.latitude),
        lng: Number(center.longitude)
    };
};

/* process the data returned from the http API
 NOTE: this reducer runs against a "synthetic" action, with a 
 suffix of "_COMPLETED" added to the original action type. This
 action is created by the api middleware in response to the original
 action and the payload contains the returned JSON
 */

const resetState = state => ({
    ...state,
    geographicCenter: null,
    ungroupedLocations: [],
    manyItemStates: [],
    fewItemStates: [],
    showingAll: false,
    error: null,
    jumpToCurrentLocationError: null
});
const locationIndexReducer = createReducer(initState)({
    [t.LOAD_ALL_LOCATIONS + "_STARTED"]: (state, action) => ({
        ...resetState(state),
        error: null,
        loading: true
    }),
    [t.LOAD_ALL_LOCATIONS + "_FAILED"]: (state, action) => ({
        ...state,
        error: action.payload,
        loading: false
    }),
    [t.LOAD_ALL_LOCATIONS + "_COMPLETED"]: (state, action) => ({
        ...resetState(state),
        loading: false,
        error: null,
        showingAll: true,
        ungroupedLocations: action.payload,
        manyItemStates: getManyItemStates(action.payload),
        fewItemStates: getFewItemStates(action.payload),
        geographicCenter: getGeographicCenter(action.payload)
    }),

    [t.LOAD_LOCATIONS + "_STARTED"]: (state, action) => ({
        ...resetState(state),
        error: null,
        loading: true
    }),
    [t.LOAD_LOCATIONS + "_FAILED"]: (state, action) => ({
        ...state,
        error: action.payload,
        loading: false
    }),
    [t.LOAD_LOCATIONS + "_COMPLETED"]: (state, action) => ({
        ...resetState(state),
        loading: false,
        error: null,
        showingAll: false,
        ungroupedLocations: action.payload,
        manyItemStates: getManyItemStates(action.payload),
        fewItemStates: getFewItemStates(action.payload),
        geographicCenter: getGeographicCenter(action.payload)
    })
});

export default locationIndexReducer;



// WEBPACK FOOTER //
// ./ducks/location-index/reducers.js